import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Default to 'light' theme
    try {
      const savedTheme = localStorage.getItem('theme');
      const initialTheme = savedTheme || 'light';
      
      // Apply theme immediately to avoid flash
      if (initialTheme === 'dark') {
        document.documentElement.setAttribute('data-theme', 'dark');
      } else {
        // Remove attribute for light theme (uses :root default)
        document.documentElement.removeAttribute('data-theme');
      }
      
      return initialTheme;
    } catch (error) {
      // Ensure light theme is applied on error
      document.documentElement.removeAttribute('data-theme');
      return 'light';
    }
  });

  useEffect(() => {
    // Apply theme to document root
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      // Remove attribute for light theme (uses :root default)
      document.documentElement.removeAttribute('data-theme');
    }
    
    // Save theme preference
    try {
      localStorage.setItem('theme', theme);
    } catch (error) {
      console.error('Error saving theme preference:', error);
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

